<template>
  <div class="row">
    <div class="col-md-6">
      <b-card :header="displayName">
        {{displayName}}
        <span slot="footer">Go to <!-- <router-link class="font-weight-bold" :to="'/employees/' + detailedInfo.id"> -->profile<!-- </router-link> --> page</span>
      </b-card>
      <card-list-info header="Detail" :items="accountInfo"></card-list-info>
    </div>
    <div class="col-md-6">
      <!-- <b-card header="Transfer employee">
        <label>Company</label>
        <multiselect
            v-model="selectedCompany"
            :options="companies"
            label="name"
            track-by="id"
            placeholder="Select company" class="mb-4"/>
        <b-button variant="primary">Transfer</b-button>
      </b-card> -->
      <!-- <b-card header="Set vehicle for this driver" v-show="setInfo == null && detailedInfo.type == 'DRIVER'">
        <label>Vehicle</label>
        <multiselect
            v-model="selectedVehicle"
            :options="unassignVehicles"
            label="reg_no"
            track-by="id"
            placeholder="Select vehicle" class="mb-4"/>
        <b-button variant="primary" @click="setVehicle()">Set</b-button>
      </b-card> -->
      <b-card
        v-if="canIDeleteEmployee(detailedInfo)"
        header-bg-variant="danger"
        border-variant="danger"
        header="Remove this employee">
        <p>Removing employees has the following effects: </p>
        <ul class="pl-4">
          <li>Employee won't be able to use the app</li>
          <li>Driver assigned to vehicle will be removed</li>
          <li>Some information on shipment or order confirmation will be missing</li>
        </ul>
        <b-button v-b-modal.delete_employee variant="danger">Remove</b-button>
      </b-card>
    </div>
    <div>
      <b-modal
        id="delete_employee"
        title="Delete Employee"
        header-bg-variant="danger"
        ok-variant="danger"
        @ok="deleteEmployee()">
        <p class="my-4">Are you sure want to delete this employee ?</p>
      </b-modal>
    </div>
  </div>
</template>
<script>

import dateMixin from '@/mixins/date';
import employeeMixin from '@/mixins/employee';
import CardListInfo from '@/components/CardListInfo';
import Multiselect from 'vue-multiselect';

export default {
  mixins: [dateMixin, employeeMixin],
  components: {
    CardListInfo,
    Multiselect,
  },
  data() {
    return {
      selectedCompany: null,
      // selectedVehicle: null,
    };
  },
  created() {
    this.$store.dispatch('employees/LOAD_DETAIL_DATA');
    // this.$store.commit('companies/CLEAR_QUERY');
    // this.$store.dispatch('companies/LOAD_INFO').then(() => {
    //   this.$store.commit('companies/SET_QUERY_COUNT', this.count_all);
    //   this.$store.dispatch('companies/LOAD_DATA');
    // });
    this.$store.dispatch('vehicles/LOAD_INFO').then(() => {
      this.$store.commit('vehicles/SET_QUERY_COUNT', this.count_vehicle);
      this.$store.dispatch('vehicles/LOAD_DATA');
    });
  },
  computed: {
    // companies() {
    //   return this.$store.getters['companies/companies'];
    // },
    // unassignVehicles() {
    //   const vehicles = this.$store.getters['vehicles/vehicles'];
    //   return vehicles.filter(vehicle => !vehicle.driver);
    // },
    displayName() {
      return this.detailedInfo.name;
    },
    detailedInfo() {
      return this.$store.getters['employees/get_detail_data'];
    },
    // count_all() {
    //   return this.$store.getters['companies/count_all'];
    // },
    accountInfo() {
      const info = this.detailedInfo;

      const infoList = [
        { key: 'name', label: 'Name', value: info.name },
        { key: 'number', label: 'Number', value: info.number },
        { key: 'dob', label: 'Date of Birth', value: this.formatDate(info.dob) },
        {
          key: 'created_at',
          label: 'Created at',
          value: this.formatDateDistance(info.created_at),
          title: this.formatDateTime(info.created_at),
        },
      ];

      return infoList;
    },
    myAccess() {
      return this.$store.getters.userAccess;
    },
    count_vehicle() {
      return this.$store.getters['vehicles/count_all'];
    },
    // setInfo() {
    //   let { vehicle } = this.detailedInfo;
    //   vehicle = vehicle || null;
    //   return vehicle;
    // },
  },
  // watch: {
  //   detailedInfo(data) {
  //     this.selectedCompany = data.company;
  //   },
  // },
  methods: {
    deleteEmployee() {
      this.$store.dispatch('employees/DELETE_DATA').then((ok) => {
        if (ok) this.$router.push('/admin/employees');
      });
    },
    // setVehicle() {
    //   const data = {
    //     vehicle_id: this.selectedVehicle.id,
    //     employee_id: this.detailedInfo.id,
    //   };
    //   this.$store.dispatch('vehicles/CREATE_VEHICLE_DRIVER', data).then(() => {
    //     this.$swal('Success', 'Success set vehicle', 'success').then(() => {
    //       this.$store.dispatch('employees/LOAD_DETAIL_DATA');
    //     });
    //   });
    // },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/admin/employees/detail/Preview.vue